import { takeLatest, put, call, all } from "redux-saga/effects";
import ReportActionTypes from "./report.types";
import { firestore } from "../../utils/firebase/firebase.util";
import {
  fetchReportsStart,
  fetchReportsSuccess,
  fetchReportsFailure,
  saveReportSuccess,
  saveReportFailure,
  addReport,
  setCurrentReport,
  rateReportFailure,
  rateReportSuccess,
  getUserRatingSuccess,
  getUserRatingFailure,
} from "./report.actions";

export function* fetchReportsAsync() {
  try {
    const reportRef = firestore.collection("reports");
    const snapshot = yield reportRef.get();
    const transformedReports = yield snapshot.docs.map((doc) => {
      return { id: doc.id, ...doc.data() };
    });
    yield put(fetchReportsSuccess(transformedReports));
  } catch (error) {
    yield put(fetchReportsFailure(error));
  }
}
export function* fetchReportByIdAsync({ payload }) {
  try {
    const reportRef = firestore.collection("reports").doc(payload);
    const snapShot = yield reportRef.get();
    yield put(setCurrentReport({ id: snapShot.id, ...snapShot.data() }));
  } catch (error) {
    yield put(fetchReportsFailure(error));
  }
}

export function* saveReportAsync({ payload }) {
  const report = payload.report;
  const callback = payload.callback;
  try {
    if (report.id) {
      // Update Report
      const doc = yield firestore.collection("reports").doc(report.id);
      yield doc.set(report);
    } else {
      //create new one
      const ref = yield firestore.collection("reports").add({ ...report });
      report.id = ref.id;
      yield put(addReport(report));
    }
    if (callback != null) {
      callback();
    }
    yield put(saveReportSuccess(report));
    yield put(fetchReportsStart());
  } catch (error) {
    yield put(saveReportFailure(error));
  }
}
export function* rateReportAsync({ payload }) {
  //payload: (report, user, rating)
  try {
    const rateId = payload.report.id + "+" + payload.user.id;
    const doc = yield firestore.collection("bewertungen").doc(rateId);
    const rating = {
      value: payload.value,
      reportRef: firestore.collection("reports").doc(payload.report.id),
      userRef: firestore.collection("users").doc(payload.user.id),
      gemeindeRef: payload.user.gemeindeRef,
      erstellt: new Date(),
    };
    yield doc.set(rating);
    yield put(rateReportSuccess(rating));
  } catch (error) {
    yield put(rateReportFailure(error));
  }
}
export function* getUserRatingAsync({ payload }) {
  try {
    const rateId = payload.reportId + "+" + payload.user.id;

    const rateRef = firestore.collection("bewertungen").doc(rateId);
    const snapShot = yield rateRef.get();
    const data = snapShot.data();
    if (data) {
      data["erstellt"] = data.erstellt.toDate();
    }
    console.log(data);
    yield put(
      getUserRatingSuccess({
        ...data,
      })
    );
  } catch (error) {
    yield put(getUserRatingFailure(error));
  }
}

export function* onFetchReport() {
  yield takeLatest(ReportActionTypes.FETCH_REPORTS_START, fetchReportsAsync);
}

export function* onSaveReport() {
  yield takeLatest(ReportActionTypes.SAVE_REPORT_START, saveReportAsync);
}

export function* onGetReportByID() {
  yield takeLatest(
    ReportActionTypes.SET_CURRENT_REPORT_BY_ID,
    fetchReportByIdAsync
  );
}

export function* onRateReport() {
  yield takeLatest(ReportActionTypes.RATE_REPORT_START, rateReportAsync);
}

export function* onGetReportRating() {
  yield takeLatest(ReportActionTypes.GET_USER_RATING_START, getUserRatingAsync);
}

export function* reportSagas() {
  yield all([
    call(onFetchReport),
    call(onSaveReport),
    call(onGetReportByID),
    call(onRateReport),
    call(onGetReportRating),
  ]);
}
